import BinIcon from "../icon/Icon";
import { useCallback } from "react";
import appHistory from "../../app/appHistory";
import { useGTMEvent } from "../../modules/GoogleTagManager/googleTagManagerHooks";

function BackButton(props) {
    const {
        onClickHandler,
    } = props;
    const {handleGTMClick} = useGTMEvent();

    const clickHandler = useCallback(() => {
        handleGTMClick({
            module: 'BackButton',
            button: 'back'
        });
        if (onClickHandler) {
            onClickHandler();
        } else {
            appHistory.goBack();
        }
    }, [onClickHandler, handleGTMClick]);

    return <div style={{textAlign: 'left', marginBottom: '24px'}}>
        <span onClick={clickHandler} style={{cursor: 'pointer'}}><BinIcon name={'IcMoveLeft'}/></span>
    </div>
}

export default BackButton;
